import React from 'react';
import { loginWithGoogle } from '../services/authService';

const LoginGate = () => {
  return (
    <div style={styles.container}>
      <div style={styles.card}>
        <h2>Welcome to our Atelier</h2>
        <p>Please log in to start creating your Masterpiece.</p>
        {/* The Login Button */}
        <button onClick={loginWithGoogle} style={styles.googleBtn}>
          <img
            src="https://www.gstatic.com/firebasejs/ui/2.0.0/images/auth/google.svg"
            alt="G"
            style={styles.icon}
          />
          Sign in with Google
        </button>

        <p style={styles.note}>No password required.</p>
      </div>
    </div>
  );
};

// Simple inline styles to make it look good immediately
const styles = {
  container: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    height: '100vh',
    backgroundColor: '#f5f5f5',
  },
  card: {
    padding: '40px',
    background: 'white',
    borderRadius: '12px',
    boxShadow: '0 4px 6px rgba(0,0,0,0.1)',
    textAlign: 'center',
    maxWidth: '400px',
    width: '100%',
  },
  googleBtn: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: '100%',
    padding: '12px',
    marginTop: '20px',
    backgroundColor: 'white',
    border: '1px solid #dadce0',
    borderRadius: '4px',
    fontSize: '16px',
    fontWeight: '500',
    color: '#3c4043',
    cursor: 'pointer',
    transition: 'background 0.2s',
  },
  icon: {
    width: '18px',
    height: '18px',
    marginRight: '10px',
  },
  note: {
    marginTop: '15px',
    fontSize: '0.8em',
    color: '#888',
  }
};

export default LoginGate;